import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUserWallet = function SvgUserWallet(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24764",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24764)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24764)",
        fillOpacity: 0.16,
        d: "M21.949 70.667q-1.921 0-3.269-1.347-1.347-1.347-1.347-3.269V21.95q0-1.921 1.347-3.269 1.347-1.347 3.269-1.347H66.05q1.921 0 3.269 1.347 1.347 1.347 1.347 3.269V66.05q0 1.921-1.347 3.269-1.347 1.347-3.269 1.347z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24764)",
        d: "M15.898 61.917q4.743-4.539 10.843-7.254t13.25-2.714 13.259 2.715 10.853 7.253V17.949q0-.77-.641-1.41-.642-.642-1.41-.642H17.948q-.77 0-1.41.641-.642.642-.642 1.41zM40.07 44.34q4.16 0 7.044-2.885Q50 38.571 50 34.41t-2.885-7.045-7.044-2.884-7.045 2.884q-2.885 2.886-2.885 7.045 0 4.16 2.885 7.045t7.044 2.885M17.949 66.667q-1.921 0-3.269-1.347-1.347-1.347-1.347-3.269V17.95q0-1.921 1.347-3.269 1.347-1.347 3.269-1.347H62.05q1.921 0 3.269 1.347 1.347 1.347 1.347 3.269V62.05q0 1.921-1.347 3.269-1.347 1.347-3.269 1.347zm-.032-2.564h44.23v-.558q-4.884-4.54-10.504-6.785A31.1 31.1 0 0 0 40 54.513q-5.969 0-11.583 2.215-5.616 2.214-10.5 6.689zm22.186-22.327q-3.093 0-5.245-2.153-2.153-2.151-2.153-5.213 0-3.06 2.153-5.213 2.151-2.152 5.213-2.152 3.06 0 5.213 2.165t2.152 5.168q0 3.093-2.166 5.246-2.165 2.151-5.167 2.152"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24764",
        x1: 17.89,
        x2: 69.924,
        y1: 43.999,
        y2: 43.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24764",
        x1: 13.89,
        x2: 65.924,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgUserWallet as ReactComponent };
//# sourceMappingURL=UserWallet.svg.es.js.map
